module.exports = __webpack_public_path__ + "img/UTJORD-2.48cb35c0.jpg";